import { useCallback, useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import { Box } from "@mui/system";
import Logo from "./logo";
import LoadingButton from "@mui/lab/LoadingButton";
import { useDispatch } from "react-redux";
import { setToken, setCustomer, logged } from "@store/account/account.slice";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { handleReCaptchaVerifyUtil } from "@functions/reacptchaCallback";
import * as yup from "yup";
import { loginAction } from "./functions";
import $axios from "@utils/axios";
import { toast } from "react-hot-toast";
import { useStateCallback } from "@utils/useStateCallback";
import { ConfirmOtpLogin } from "./otpDialogLogin";

const Login = () => {
  const dispatch = useDispatch();
  const { t }: any = useTranslation();
  const { executeRecaptcha } = useGoogleReCaptcha();
  //States
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [isSend2fa, setIsSend2fa] = useState<boolean>(false);
  const [code, setCode] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [qrCode, setQrCode] = useState<string>("");
  const [formTest1, setFormTest1] = useStateCallback({});

  const [otpModalOpen, setOtpModalOpen] = useState<boolean>(false);
  console.log("otpModalOpen: ", otpModalOpen);

  const handleReCaptchaVerify = handleReCaptchaVerifyUtil(
    useCallback,
    executeRecaptcha
  );
  const loginValidation = (t: any) => {
    return yup.object({
      email: yup
        .string()
        .email(t("Enter a valid email"))
        .required(t("Email is required")),
      password: yup.string().required(t("Password is required")),
    });
  };

  const send2fa = async (values: { email: string; password: string }) => {
    setEmail(values.email);
    const { data } = await $axios.post("/auth/send2fa", {
      email: values.email,
    });

    if (data.success) {
      if (data.message == "skip") {
        login(values);
      } else if (data.message == "code") {
        setIsSend2fa(true);
        setQrCode("");
      } else {
        setIsSend2fa(true);
        setQrCode(data.message);
      }
    } else {
      toast.error(data.message);
    }
  };

  const verify2fa = async () => {
    const r: any = await $axios.post("/auth/verify2fa", {
      email,
      code,
      field: "two_fa_secret_portal",
    });
    if (r.data.success) {
      setIsSend2fa(false);
      login();
    } else {
      toast.error(r.data.message);
    }
  };
  //Effects
  useEffect(() => {
    handleReCaptchaVerify();
  }, [handleReCaptchaVerify]);

  // useEffect(() => {
  //   if (formTest1.email != null && formTest1.email != "") {
  //     send2fa();
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [formTest1]);

  const login = async (v?: { email: string; password: string }) => {
    const res = await loginAction(
      v ? v : formTest1,
      setIsLoading,
      handleReCaptchaVerify,
      (data: any) => dispatch(setToken(data)),
      (data: any) => dispatch(setCustomer(data)),
      (data: any) => dispatch(logged(data))
    );

    if (res === "Customer Not Active") {
      // setOtpModalOpen(true);
    } else if (res === "password to short") {
      location.href = "/forgot-password-force";
    }
  };
  //validations
  const validationSchema = loginValidation(t);
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (values.email != "" && values.email != null) {
        setFormTest1(values, send2fa(values));
      }
    },
  });

  useEffect(() => {
    document.title = "NetNut Login | netnut.io";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Log in to access your dedicated proxy dashboard. Harness fast, reliable, and secure proxy solutions tailored to your needs. Join the next generation of proxy services."
      );
    } else {
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content =
        "Log in to access your dedicated proxy dashboard. Harness fast, reliable, and secure proxy solutions tailored to your needs. Join the next generation of proxy services.";
      document.head.appendChild(meta);
    }
  }, []);

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      sx={{ textAlign: "center", backgroundColor: "#f5faff", height: "100vh" }}
    >
      <Dialog
        sx={{
          borderRadius: "20px",
        }}
        open={isSend2fa}
        onClose={() => setIsSend2fa(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {qrCode != "" && <Typography>Two Factor Authentication</Typography>}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {qrCode != "" && (
              <Box>
                <Box sx={{ textAlign: "center" }}>
                  <img src={qrCode} />
                </Box>
                For the first registration, please scan this QR code with a
                security or authentication app like Google Authenticator,
                Microsoft Authenticator, Authy, etc, and insert the code in
                verification box.
                <br /> Download one from the App Store or Google PlayStore.
              </Box>
            )}
            <Typography>Please enter the code from your 2fa app</Typography>
            <TextField
              sx={{
                mt: 2,
                width: "100%",
              }}
              autoFocus
              variant="outlined"
              label={t("Code")}
              value={code}
              onChange={(v: React.ChangeEvent<HTMLInputElement>) =>
                setCode(v.target.value)
              }
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" fullWidth onClick={() => verify2fa()}>
            Verify
          </Button>
        </DialogActions>
      </Dialog>
      <Grid item sx={{ width: "377px" }}>
        <Box
          sx={{
            px: 2,
          }}
        >
          <Logo />

          <Typography
            fontWeight={3}
            variant="h1"
            sx={{
              mt: 10,
              fontSize: "24px",
              fontWeight: 600,
              fontStretch: "normal",
              color: "#333",
            }}
          >
            {t("Welcome back")}
          </Typography>

          <form
            onSubmit={(e) => {
              e.preventDefault();
              formik.handleSubmit(e);
            }}
          >
            <Box sx={{ mt: 4 }}>
              <TextField
                fullWidth
                variant="outlined"
                label={t("Email")}
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
              />
            </Box>
            <Box sx={{ mt: 2 }}>
              <TextField
                fullWidth
                name="password"
                placeholder={t("Password")}
                label={t("Password")}
                type={showPassword ? "text" : "password"}
                value={formik.values.password}
                onChange={formik.handleChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label={t("toggle password visibility")}
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <LoadingButton
              sx={{
                mt: 3,
                mb: 2,
              }}
              variant="contained"
              color="secondary"
              loading={isLoading}
              loadingIndicator="Loading..."
              fullWidth
              type="submit"
            >
              {t("Login to NetNut")}
            </LoadingButton>
          </form>

          <Typography color="#c1c5c8">
            {t("Forgot your password?")}{" "}
            <Link
              style={{ fontWeight: "bold", color: "#fbb690" }}
              to="/forgot-password"
            >
              {t("reset now")}
            </Link>
          </Typography>

          <Typography sx={{ mt: 4 }}>
            {t("Don't have an account?")}{" "}
            <Link
              to="/register"
              style={{ fontWeight: "bold", color: "#7e64c5" }}
            >
              {t("Create Account!")}
            </Link>
          </Typography>
        </Box>
      </Grid>
      <ConfirmOtpLogin
        open={otpModalOpen}
        setOpen={setOtpModalOpen}
        handleNext={() => console.log("handleNext")}
        email={formik.values.email}
        password={formik.values.password}
        setIsLoading={setIsLoading}
        dispatchToken={(data: any) => dispatch(setToken(data))}
        dispatchCustomer={(data: any) => dispatch(setCustomer(data))}
        dispatchLogged={(data: any) => dispatch(logged(data))}
      />
    </Grid>
  );
};

export default Login;
